import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import { CoreLink } from '@uncinc/react-drupal-core';

import './style.scss';

export interface Funder {
  title: string;
  url: string;
}

export interface FundersWidgetProps {
  funders: Funder[];
  className?: string;
}

const FundersWidget: React.FC<FundersWidgetProps> = (props) => {
  const { funders, className } = props;

  const { t } = useTranslation('translation', { keyPrefix: 'components.widgets.funders_widget' });

  const classes = c('FundersWidget', 'Paper', className);

  return (
    <div className={classes}>
      <h3 className="FundersWidget__title">
        {t('title')}
      </h3>

      <ul className="FundersWidget__list">
        {funders.map(({ title, url }, index) => (
          <li key={`funder-${title}-${index + 1}`}>
            <CoreLink href={url}>
              {title}
            </CoreLink>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FundersWidget;
